export const images = {
  doctor: {
    main: "/images/doctor-main.jpg",
    consultation: "/images/doctor-from-future-concept.jpg",
  },
  hero: {
    bg: "/images/hero-bg.jpg",
  },
  services: {
    stroke: "/images/service-stroke.jpg",
    headache: "/images/service-headache.jpg",
    epilepsy: "/images/service-epilepsy.jpg",
    neuropathy: "/images/service-neuropathy.jpg",
    vertigo: "/images/service-vertigo.jpg",
    backpain: "/images/service-backpain.jpg",
    myasthenia: "/images/service-myasthenia.jpg",
    infection: "/images/service-infection.jpg",
    neuralgia: "/images/service-neuralgia.jpg"
  },
  clinic: {
    interior: "/images/clinic-interior.jpg",
    exterior: "/images/clinic-exterior.jpg"
  },
  blog: {
    migraine: "/images/service-headache.jpg",
    neckpain: "/images/blog-neckpain.jpg"
  },
  contact: {
    whatsappScanner: "/images/whatsapp-scanner.png"
  }
};
